<script lang="ts" setup>
interface Props {
  as: 'td' | 'th'
}

defineProps<Props>()
</script>

<template>
  <tr>
    <component
      :is="as"
      class="px-2 py-1 text-left text-xl font-normal uppercase text-primary"
      style="background: #eae7e0"
      v-bind="$attrs"
    >
      <slot />
    </component>
  </tr>
  <tr>
    <component :is="as" style="height: 5px" v-bind="$attrs" />
  </tr>
</template>
